import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MainContainer, OutlinedButton, PaperBox, SadFace } from '../index';
import { useEnvironment } from '../contexts';
export var Error401 = function Error401() {
    var environment = useEnvironment().environment;
    var backHome = function backHome() {
        window.location.href = environment.dashboardUrl;
    };
    var signOut = function signOut() {
        window.location.href = environment.dashboardUrl + '/logout';
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsx(PaperBox, {
            footer: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center w-full",
                children: [
                    /*#__PURE__*/ _jsx(OutlinedButton, {
                        label: "Back to Home page",
                        onClick: backHome
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ml-4",
                        children: /*#__PURE__*/ _jsx(OutlinedButton, {
                            label: "Sign Out",
                            onClick: signOut
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center justify-between mt-8 w-full gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-row items-center mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx(SadFace, {}),
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "ml-2 text-[var(--color-primary-error)] text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0",
                                        children: "Authorization Error"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "font-normal text-sm text-[var(--color-secondary)]",
                                children: [
                                    "Sorry, you don't have an access to this page",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "Request access from the manager of your organization."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "/vectors/not-authorized.svg",
                        alt: "Not Authorized Illustration",
                        width: "240",
                        height: "140"
                    })
                ]
            })
        })
    });
};
